
















import Vue, { PropType } from "vue";
import { INVERTER_SERIAL_LENGTH, serialFromScan } from "@/helpers/serial-number";

export default Vue.extend({
  name: "Scanner",

  props: {
    duplicates: {
      type: Function as PropType<(code: string) => boolean>,
      default: () => () => true
    },
    // How much of a barcode is the serial; 0 keeps all of it. See serialFromScan().
    scanLength: {
      type: Number,
      default: INVERTER_SERIAL_LENGTH
    }
  },

  data() {
    return {
      barcodeReader: null as any,
      snackbarVisible: false,
      snackbarMessage: "",
      snackbarColor: "success"
    };
  },

  computed: {
    strichApiKey(): string {
      return this.$store.getters["strichApiKey"];
    }
  },

  destroyed() {
    this.stop();
  },

  methods: {
    async loadScript(): Promise<void> {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src =
          "https://cdn.jsdelivr.net/npm/@pixelverse/strichjs-sdk@latest/dist/strich-noesm.js";
        script.async = true;
        script.onload = result => {
          if ("strich" in window) {
            resolve((window as any).strich);
          } else {
            reject(new Error("Failed to initialize STRICH library"));
          }
        };
        script.onerror = () => reject(new Error("Failed to load STRICH"));
        document.body.appendChild(script);
      });
    },

    async start() {
      this.loadScript().then((strich: any) => {
        const { StrichSDK, BarcodeReader } = strich;
        StrichSDK.initialize(this.strichApiKey).then(() => {
          const configuration = {
            selector: "#scanner",
            engine: {
              symbologies: ["code128"],
              duplicateInterval: 1500
            },
            locator: {
              regionOfInterest: {
                left: 0.05,
                right: 0.05,
                top: 0.4,
                bottom: 0.4
              }
            },
            frameSource: {
              resolution: "full-hd"
            },
            overlay: {
              showFlashlight: false
            },
            mode: "immediate",
            feedback: {
              audio: true,
              vibration: true
            }
          };
          this.barcodeReader = new BarcodeReader(configuration);

          this.barcodeReader.initialize().then(() => {
            this.barcodeReader.detected = (newDetections: { data: string }[]) => {
              newDetections.forEach(detection => {
                const serial = serialFromScan(detection.data, this.scanLength);
                if (this.duplicates(serial)) {
                  this.snackbarMessage = `${serial} is al gescand`;
                  this.snackbarColor = "error";
                  this.snackbarVisible = true;
                } else {
                  this.$emit("add", { serialNumber: serial, source: "scan" });
                  this.snackbarMessage = `${serial} gescand`;
                  this.snackbarColor = "success";
                  this.snackbarVisible = true;
                }
              });
            };
            this.barcodeReader.start();
          });
        });
      });
    },
    async stop() {
      this.barcodeReader.destroy();
      try {
        await document.exitFullscreen();
      } catch (e) {
        // do nothing
      } finally {
        this.$emit("close");
      }
    }
  }
});
